import { render, staticRenderFns } from "./ExpressInfo.vue?vue&type=template&id=636816d0"
import script from "./ExpressInfo.vue?vue&type=script&lang=js"
export * from "./ExpressInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports